import React from 'react';
import OpenLDAPHeroContent from './OpenLDAPHeroContent';
import OpenLDAPHeroImage from './OpenLDAPHeroImage';

interface OpenLDAPHeroProps {
  title: string;
  description: string;
  buttonText: string;
}

const OpenLDAPHero: React.FC<OpenLDAPHeroProps> = ({ title, description, buttonText }) => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
      <OpenLDAPHeroContent 
        title={title}
        description={description}
        buttonText={buttonText}
      />
      <OpenLDAPHeroImage />
    </div>
  );
};

export default OpenLDAPHero;